import { combineReducers } from "redux";
import templatesReducer from "./templatesReducer";
import editorReducer from "./editorReducer";
import errorsReducer from "./errorsReducer";
import triggerReducer from "./triggerReducer";

export default combineReducers({
	templatesReducer,
	editorReducer,
	errorsReducer,
	triggerReducer,
});
